export default function Footer() {
  const year = new Date().getFullYear();
  const goAnchor = (e: React.MouseEvent, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer id="contact" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#home" onClick={(e) => goAnchor(e, "#home")} className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-foreground-900">
                吃瓜<span className="text-primary-600">每日</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              把吃瓜变成一种轻松日常。打卡、日常追瓜、蹲更新、定时刷新、睡前必看、通勤速览,
              让你不错过圈内任何一条新瓜。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-tiktok-line", "ri-bilibili-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#home"
                    onClick={(e) => e.preventDefault()}
                    aria-label="关注吃瓜每日社交账号"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-200 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={icon}></i>
                  </a>
                )
              )}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">快捷导航</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                ["#hot", "今日热瓜"],
                ["#schedule", "每日时段"],
                ["#categories", "瓜圈分类"],
                ["#feed", "最新瓜报"],
                ["#habits", "吃瓜习惯"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={(e) => goAnchor(e, href)}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">栏目分类</h4>
            <ul className="mt-4 space-y-2.5">
              {["综艺现场", "剧集一线", "音乐风云", "影坛新事", "明星动态", "圈内幕后"].map(
                (c) => (
                  <li key={c}>
                    <a
                      href="#categories"
                      onClick={(e) => goAnchor(e, "#categories")}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {c}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-primary-500"></i>
                hi@chigua-daily.example.com
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-24-hours-line text-primary-500"></i>
                每日 08:00 – 23:00 蹲更
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-chat-smile-3-line text-primary-500"></i>
                投稿、报料与意见反馈,欢迎来信沟通
              </li>
            </ul>
            <a
              href="#signup"
              onClick={(e) => goAnchor(e, "#signup")}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-600 ring-1 ring-background-200 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-mail-send-line"></i>
              订阅瓜报
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} 吃瓜每日 · 让吃瓜成为你的日常
          </p>
          <p className="text-xs text-foreground-500">
            内容仅供参考与娱乐 · 请理性看待网络信息
          </p>
        </div>
      </div>
    </footer>
  );
}